export default __webpack_public_path__ + "static/media/scratcher-manual-entry.c636d724.webm";